//Initialize Accordion
if(document.querySelector('.accordion-container')){
  new Accordion(".accordion-container");
}

//Carousel Script
//document.querySelectorAll(".glide__slides")
if (document.querySelector(".glide__slides")) {
  var allSlides = document.querySelectorAll(".glide");
  var allSlidesArray = Array.prototype.slice.call(allSlides);
  allSlidesArray.forEach((slide) => {
    const glide = new Glide(slide, {
      type: "slider",
      perView: 3,
      perTouch: 1,
      focusAt: "center",
      autoplay: false,
      accessibility: true,
      startAt: 2,
      rewind: false,
      classes: {
        disabledArrow: "glide__arrow--disabled",
      },
      peek: {
        before: 100,
        after: 50,
      },
      perSwipe: "|",
      breakpoints: {
        800: {
          perView: 1,
          startAt: 1,
          peek: 0,          
        },
      },
    }).mount();
  });
}

// $('.glide__arrow--right').on('click', function () {
//   $('.glide__arrow--right').removeClass('disabled');

//   var totalslides = $('.glide__bullet').length;

//   if ($('.glide__bullet')[totalslides - 1].hasClass('glide__bullet--active')) {
//     console.log('last');
//     $('.glide__arrow--right').addClass('disabled');
//   }
// })

//Check if Header Button link is external
if (document.querySelector(".cta-btn")) {
  let currentHost = window.location.hostname;
  let ctaBtn = document.querySelector(".cta-btn");
  let ctaLink = ctaBtn.getAttribute("href").split("/");

  if (ctaLink[0] !== currentHost) {
    ctaBtn.classList.add("external-link");
  }
}

//Menu
let hamicon = document.querySelector(".hamicon");
let nav = document.querySelector("#site-navigation");
let hamMenu = document.querySelector(".main-navigation.hamburger-menu");
const mq = window.matchMedia("(max-width: 767px)");

//Ham Menu
if (hamMenu) {
  hamMenu.style.display = "none";
}
mq.onchange = (e) => {
  if (mq.matches) {
    nav.style.display = "none";
    hamicon.style.display = "block";

    if (document.querySelector(".mobile-menu-icon")) {
      document.querySelector(".mobile-menu-icon").style.display = "block";
    }    

  } else {
    nav.style.display = "block";
    hamicon.style.display = "none";
    document.querySelector(".mobile-menu-icon").style.display = "none"; 
    document.querySelector('#primary-menu').style.height = "auto";
  }
};
mq.onchange();

let openMobileNav = (e) => {
  hamicon.classList.toggle("is-active");
  nav.classList.toggle("active");
  document.getElementById("overlay").classList.toggle("active");
  document.getElementsByTagName("BODY")[0].classList.toggle("no-scroll");
  nav.focus();

  let menuLabel = document.querySelector(".mobile-menu-label");
  let menuParentList = document.querySelector('#primary-menu');
  let menuFromTop = menuParentList.getBoundingClientRect().top;

  menuParentList.classList.toggle('active-submenu');

  if (menuLabel) {
    if (nav.classList.contains("active")) {
      menuLabel.innerText = "Close"; 
      hamicon.setAttribute('aria-label', 'close the menu');
      menuParentList.style.height = 'calc(100vh - ' + menuFromTop + 'px)';    
    } else {
      menuLabel.innerText = "Menu";
      hamicon.setAttribute('aria-label', 'open the menu');
    }
  }

};

hamicon.addEventListener("click", openMobileNav);
hamicon.addEventListener("keydown", (e) => {
  if (e.keyCode == 13 || e.keyCode == 32) {
    openMobileNav();
  }
});

//Submenu Arrow Icon
var arrowchevron = document.createElement("div");
arrowchevron.classList.add("arrow-down");
arrowchevron.setAttribute("tabindex", 0);
arrowchevron.setAttribute("role", 'button');
arrowchevron.setAttribute('aria-label', 'Open Submenu');
//arrowchevron.innerHTML = '<span class="screen-reader-text">Technology</span>'

let parentMenu = document.querySelectorAll(".menu-item-has-children > a");
let allparentMenu = Array.prototype.slice.call(parentMenu);

allparentMenu.forEach((menu) => {
  menu.setAttribute("aria-haspopup", true);
  menu.appendChild(arrowchevron.cloneNode(true));

  let arrow = menu.children[0],
    submenu = menu.nextSibling.nextSibling;

  arrow.addEventListener("click", (e) => {
    arrow.classList.toggle("rotate");
    submenu.classList.toggle("open-submenu");

    if (submenu.classList.contains("open-submenu")) {
      submenu.setAttribute("aria-expanded", true);
      arrow.setAttribute('aria-label', 'Close Submenu');
    } else {
      submenu.setAttribute("aria-expanded", false);
      arrow.setAttribute('aria-label', 'Open Submenu');
    }
    e.preventDefault();
  });

  arrow.addEventListener("keydown", (e) => {
    if (e.keyCode == 13 || e.keyCode == 32) {
      arrow.classList.toggle("rotate");
      submenu.classList.toggle("open-submenu");

      if (submenu.classList.contains("open-submenu")) {
        submenu.setAttribute("aria-expanded", true);
        arrow.setAttribute('aria-label', 'Close Submenu');
      } else {
        submenu.setAttribute("aria-expanded", false);
        arrow.setAttribute('aria-label', 'Open Submenu');
      }
    }
  });
});

////Pagination
if (document.querySelector(".navigation-pagination")) {
  let paginationList = document.querySelectorAll(".navigation-pagination ul li");

  if (paginationList[0].classList.contains("active")) {
    paginationList[0].style.position = "relative";
  }

  if (paginationList[paginationList.length - 1].classList.contains("active")) {
    paginationList[paginationList.length - 1].style.position = "relative";
  }
}

// if ($('.page-heading.only-desktop').length != 0) {
//   $('article.page').css('padding', 0);
// }

////Masonary
if (document.querySelector(".allcontainer")) {
  var elem = document.querySelector(".allcontainer");
  var msnry = new Masonry(elem, {
    // options
    itemSelector: ".item",
    columnWidth: ".grid-sizer",
    gutter: 15,
  });

  //Filters
  // const filterBtn = document.querySelectorAll('.filters button');
  // var allfilterBtn = Array.prototype.slice.call(filterBtn);
  //let allblocks = document.querySelectorAll('.item');
  let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
  let selectedValue;
  let selectedOption;
  let availableItems;
  let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", onClickChange);
  }

  //Click Filter
  function onClickChange() {
    selectedValue = this.value;

    // if(selectedValue !== 'all'){
    //   allblocks = document.querySelectorAll('.item.block');
    // }
    allblocks.forEach(function (block) {
      block.classList.remove("block");

      if (selectedValue == "all") {
        block.classList.add("block");
      }

      if (block.getAttribute("data-cat") == selectedValue) {
        block.classList.add("block");
      }
    });
    msnry.layout();

    availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
    document.getElementById("select").addEventListener("change", onSelectChange);
  }

  availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

  document.getElementById("select").addEventListener("change", onSelectChange);

  function onSelectChange() {
    selectedOption = this.value;

    availableItems.forEach(function (item) {
      item.classList.remove("block");

      if (selectedOption == "all") {
        item.classList.add("block");
      }

      if (item.getAttribute("data-tag") == selectedOption) {
        item.classList.add("block");
      }
    });

    //Filter Click
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", onClickChange);
    }

    msnry.layout();
  }

  /////Script_AJAX
  /* Ajax functions */
  $(document).ready(function () {
    //onclick
    $("#loadMore").on("click", function (e) {
      e.preventDefault();
      //init
      var that = $(this);
      var page = $(this).data("page");
      var newPage = page + 1;
      var ajaxurl = that.data("url");
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: "post",
        data: {
          page: page,
          action: "ajax_script_load_more",
        },
        error: function (response) {
          console.log(response);
        },
        success: function (response) {
          //check
          if (response == 0) {
            $(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
            $("#loadMore").hide();
          } else {
            that.data("page", newPage);
            $("#ajax-primary").append(response);

            msnry = new Masonry(elem, {
              // options
              itemSelector: ".item",
              columnWidth: ".grid-sizer",
              gutter: 15,
            });

            msnry.layout();
          }
        },
      });
    });
  });
}

$("#onetrust-group-container").on("click", "button", function () {
  $(".skip-link").blur();
  $(".custom-logo-link").focus();
});

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
  var btnbgColor = $(this).css("backgroundColor");
  var btnColor = $(this).css("color");
  console.log(btnbgColor);

  $(this)
    .mouseenter(function () {
      $(this).css({ "background-color": btnColor, color: btnbgColor, "border-color": btnColor });
    })
    .mouseleave(function () {
      $(this).css({ "background-color": btnbgColor, color: btnColor, "border-color": btnbgColor });
    });
});

//vimeo video player
$(".vpop").on('click', function(e) {
  e.preventDefault();
  $("#video-popup-overlay,#video-popup-iframe-container,#video-popup-container,#video-popup-close").show();
  autoplay='',
  id=$(".vpop a").attr('href');
  if($(this).data('autoplay') == true) autoplay = '?autoplay=1';
  
  $("#video-popup-iframe").attr('src', id+autoplay);
  
  $("#video-popup-iframe").on('load', function() {
    $("#video-popup-container").show();
  });
});
$("#video-popup-close, #video-popup-overlay").on('click', function(e) {
  $("#video-popup-iframe-container,#video-popup-container,#video-popup-close,#video-popup-overlay").hide();
  $("#video-popup-iframe").attr('src', '');
});

//success-profile-page
$('.play').each(function(){
  $(this).on("keydown", (e) => {
    if (e.keyCode == 13 || e.keyCode == 32) {
      $(this).click();
    }
  })
 });